"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoyaltyStatusToJSON = exports.LoyaltyStatusFromJSONTyped = exports.LoyaltyStatusFromJSON = exports.LoyaltyStatus = void 0;
/**
 * Loyalty connection status
 * @export
 * @enum {string}
 */
var LoyaltyStatus;
(function (LoyaltyStatus) {
    LoyaltyStatus["NoConnection"] = "no_connection";
    LoyaltyStatus["ConnectionEstablished"] = "connection_established";
    LoyaltyStatus["ConnectionInactive"] = "connection_inactive";
    LoyaltyStatus["ReauthenticationNeeded"] = "reauthentication_needed";
})(LoyaltyStatus = exports.LoyaltyStatus || (exports.LoyaltyStatus = {}));
function LoyaltyStatusFromJSON(json) {
    return LoyaltyStatusFromJSONTyped(json, false);
}
exports.LoyaltyStatusFromJSON = LoyaltyStatusFromJSON;
function LoyaltyStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.LoyaltyStatusFromJSONTyped = LoyaltyStatusFromJSONTyped;
function LoyaltyStatusToJSON(value) {
    return value;
}
exports.LoyaltyStatusToJSON = LoyaltyStatusToJSON;
//# sourceMappingURL=LoyaltyStatus.js.map